import { ConnectedProps, connect } from 'react-redux'
import { ButtonPrimaryInfoLeft } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import TablePackagings from '../../../../../../specificComponents/Product/Tables/TablePackagings'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import ModalChangeActivePackaging from './ModalChangeActivePackaging'
import ModalCreatePackagingConnect from './ModalCreatePackaging'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'

type PackagingsProps = ComponentWithPermissions & ReduxPackagings & {}

const Packagings: React.FC<PackagingsProps> = ({ userPermissions, ...button }) => {
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('packagings', 'Packagings'),
        newText: t('newPackaging', 'Nuevo packaging'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TablePackagingsConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreatePackagingConnect} DeleteModalComponent={ModalChangeActivePackaging} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderPackagingTable {...{ pageData, setOpenModal, ...button, userPermissions }} />
        }>
        </BaseScreenTableSimpleStateless>)
}

type RightHeaderPackagingTableProps = ComponentWithPermissions & ReduxPackagings & {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
}

const RightHeaderPackagingTable: React.FC<RightHeaderPackagingTableProps> = ({ pageData, userPermissions, specificPriceRules, setOpenModal }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={userPermissions} permission='create'>
            {pageData.newText ? <ButtonPrimaryInfoLeft onClick={async () => setOpenModal({ type: 'create', allRowData: {} })} textButton={<span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span>} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')} /> : null}
        </PermissionChecker>
    )
}

const packagingsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapPackagingsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const packagingsConnect = connect(mapPackagingsConnector, packagingsDispatch)
type ReduxPackagings = ConnectedProps<typeof packagingsConnect>

const packagingsConnectLoading = withLoading(Packagings, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const PackagingsConnect = packagingsConnect(packagingsConnectLoading)

const tablePackagingsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapTablePackagingsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const tablePackagingsConnect = connect(mapTablePackagingsConnector, tablePackagingsDispatch)

const tablePackagingsConnectLoading = withLoading(TablePackagings, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TablePackagingsConnect = tablePackagingsConnect(tablePackagingsConnectLoading)

export default PackagingsConnect